import React from 'react';
import { McInput, McIcon } from '@maersk-global/mds-react-wrapper/components-core';

interface QuerySearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    style?: React.CSSProperties;
}

export const QuerySearchInput: React.FC<QuerySearchInputProps> = ({
    value,
    onChange,
    placeholder = 'Search by ID, name...',
    style,
}) => (
    <McInput
        label="Search queries"
        hiddenlabel
        placeholder={placeholder}
        value={value}
        onInput={(e: any) => onChange(e.target.value ?? '')}
        style={style}
    >
        <McIcon icon="magnifying-glass" slot="prefix" />
    </McInput>
);
